import * as AddressAPI from "../api/address";
import * as DummyAddressAPI from "../dummyApi/address";
import { isDemoMode } from "../stores/mode";
import type { Address, AddressResponse, SearchAddressResponse } from "../api/address";
import type { ApiResponse } from "../../types/api";

interface AddressApi {
  createAddress: (address: Address) => Promise<AddressResponse>;
  updateAddress: (address: Address) => Promise<AddressResponse>;
  setAddressAsDefault: (id: number) => Promise<ApiResponse>;
  searchAddress: (query: string, countryCodes?: string) => Promise<SearchAddressResponse>;
}

const getAPI = (): AddressApi => {
  return isDemoMode()
    ? DummyAddressAPI
    : AddressAPI;
};

export const createAddress = async (address: Address): Promise<AddressResponse> => {
  return getAPI().createAddress(address);
};

export const updateAddress = async (address: Address): Promise<AddressResponse> => {
  return getAPI().updateAddress(address);
};

export const searchAddress = async (query: string, countryCodes: string = ""): Promise<SearchAddressResponse> => {
  return getAPI().searchAddress(query, countryCodes);
};

export const setAddressAsDefault = async (id: number): Promise<ApiResponse> => {
  return getAPI().setAddressAsDefault(id);
};
